import gql from 'graphql-tag'

export const distinctKeyObjects = gql`
  query DistinctKeyObjects($entityId: Int!, $fieldId: Int!, $token: String, $userId: Int) {
    distinctKeyObjects(entityId: $entityId, fieldId: $fieldId, token: $token, userId: $userId) {
      objects
    }
  }
`
